import React from 'react';
import { Button } from '../ui/button';
import {
  FUNDING_CLAWBACK_RISKS,
  FUNDING_COMMISSION_TYPES,
  FUNDING_DEAL_STAGES,
  FUNDING_LENDER_TYPES,
  FUNDING_PRODUCT_TYPES,
} from '../../utils/funding/constants';

const Field = ({ label, children }) => (
  <label className="block text-sm">
    <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-[var(--fg-muted)]">{label}</span>
    {children}
  </label>
);

const inputClass = 'w-full rounded-xl border border-[var(--fg-line)] bg-white px-3 py-2 text-sm dark:bg-slate-950/20';

const FundingDealForm = ({ values, onChange, onSubmit, saving, error }) => {
  const set = (key, value) => onChange({ ...values, [key]: value });

  return (
    <form
      className="grid gap-4 sm:grid-cols-2"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit?.();
      }}
    >
      <Field label="Lender name">
        <input value={values.lender_name} onChange={(e) => set('lender_name', e.target.value)} className={inputClass} required />
      </Field>
      <Field label="Lender type">
        <select value={values.lender_type} onChange={(e) => set('lender_type', e.target.value)} className={inputClass}>
          <option value="">Select type</option>
          {FUNDING_LENDER_TYPES.map((type) => <option key={type} value={type}>{type}</option>)}
        </select>
      </Field>
      <Field label="Product type">
        <select value={values.product_type} onChange={(e) => set('product_type', e.target.value)} className={inputClass} required>
          {FUNDING_PRODUCT_TYPES.map((type) => <option key={type} value={type}>{type}</option>)}
        </select>
      </Field>
      <Field label="Stage">
        <select value={values.stage} onChange={(e) => set('stage', e.target.value)} className={inputClass}>
          {FUNDING_DEAL_STAGES.map((stage) => <option key={stage} value={stage}>{stage}</option>)}
        </select>
      </Field>
      <Field label="Requested amount">
        <input type="number" value={values.requested_amount} onChange={(e) => set('requested_amount', e.target.value)} className={inputClass} />
      </Field>
      <Field label="Approved amount">
        <input type="number" value={values.approved_amount} onChange={(e) => set('approved_amount', e.target.value)} className={inputClass} />
      </Field>
      <Field label="Funded amount">
        <input type="number" value={values.funded_amount} onChange={(e) => set('funded_amount', e.target.value)} className={inputClass} />
      </Field>
      <Field label="Probability (%)">
        <input type="number" min="0" max="100" value={values.probability} onChange={(e) => set('probability', e.target.value)} className={inputClass} />
      </Field>
      <Field label="Commission type">
        <select value={values.commission_type} onChange={(e) => set('commission_type', e.target.value)} className={inputClass}>
          {FUNDING_COMMISSION_TYPES.map((type) => <option key={type} value={type}>{type}</option>)}
        </select>
      </Field>
      <Field label="Commission rate">
        <input type="number" step="0.01" value={values.commission_rate} onChange={(e) => set('commission_rate', e.target.value)} className={inputClass} />
      </Field>
      <Field label="Close date">
        <input type="date" value={values.close_date} onChange={(e) => set('close_date', e.target.value)} className={inputClass} />
      </Field>
      <Field label="Clawback risk">
        <select value={values.clawback_risk} onChange={(e) => set('clawback_risk', e.target.value)} className={inputClass}>
          {FUNDING_CLAWBACK_RISKS.map((risk) => <option key={risk} value={risk}>{risk}</option>)}
        </select>
      </Field>
      <Field label="Next task">
        <input value={values.next_task} onChange={(e) => set('next_task', e.target.value)} className={inputClass} />
      </Field>
      <Field label="Next task due">
        <input type="date" value={values.next_task_due_at} onChange={(e) => set('next_task_due_at', e.target.value)} className={inputClass} />
      </Field>
      <div className="sm:col-span-2">
        <Field label="Notes">
          <textarea value={values.notes} onChange={(e) => set('notes', e.target.value)} rows={3} className={inputClass} />
        </Field>
      </div>

      {error ? (
        <div className="sm:col-span-2 rounded-xl border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-700 dark:border-rose-900/40 dark:bg-rose-950/30 dark:text-rose-200">
          {error}
        </div>
      ) : null}

      <div className="sm:col-span-2">
        <Button type="submit" className="rounded-xl bg-[var(--fg-accent)] hover:bg-[#126b4f]" disabled={saving}>
          {saving ? 'Saving...' : 'Save deal'}
        </Button>
      </div>
    </form>
  );
};

export default FundingDealForm;
